import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=a03ecfca&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=ts&"
export * from "./coupon.vue?vue&type=script&lang=ts&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=a03ecfca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03ecfca",
  null
  
)

export default component.exports